import { Box, Typography } from "@mui/material";
import "./Footer.scss"
import { useEffect, useState } from "react";

const Footer = () => {
    
    const [currentYear, setCurrentYear] = useState(0);

    useEffect(()=> {
        setCurrentYear(new Date().getFullYear());
    },[]);

    return (
 
        <Box sx={{ width: '100%', marginTop: '1.85vh' }}>
            <Typography className="text-orange text-sm" margin={'12px'}>©{ currentYear } All rights reserved.</Typography>
        </Box>
      
    )
}

export default Footer;